import React, { ReactNode } from 'react'
import { Text } from '@workwhile/ui'

type ProviderDetailLineProps = {
  label: string
  children?: ReactNode
  /** When set, renders after the label instead of children (plain text values). */
  value?: ReactNode
  color?: 'text' | 'lightText'
}

export const ProviderDetailLine = ({
  label,
  children,
  value,
  color = 'text',
}: ProviderDetailLineProps) => (
  <Text fontSize="sm" color={color} lineHeight="1.4">
    {label}: {value ?? children}
  </Text>
)
